export const environment = process.env.PDBD_ENV

export const envProduction = environment === 'production'